export function getInitials(name) {
  const matches = name.match(/\b(\w)/gu);
  let initialsString = matches?.join('') || 'U';
  if (initialsString.length > 2) {
    initialsString = initialsString[0] + initialsString.at(-1);
  }
  return initialsString.toUpperCase();
}